module.exports = "/images/participants-icon.svg?aa884838f8dad698b6c54011d00da377";